import React from 'react';
export const ComparisonSection = () => {
  const rows = [{
    sin: 'Llegás al final sin entender los temas y te quedás en blanco ante la primera pregunta del oral.',
    con: 'Sistema de preparación de 7 días con simulacro oral, flashcards y plan de estudio activo desde el día 1.'
  }, {
    sin: 'Leés el apunte 3 veces y en el examen no podés resolver los ejercicios.',
    con: '80% del tiempo en práctica activa con ejercicios resueltos y técnica de repetición espaciada.'
  }, {
    sin: 'GitHub vacío, LinkedIn incompleto. Los recruiters no te encuentran ni te llaman.',
    con: 'GitHub como portfolio profesional + LinkedIn optimizado para que los recruiters argentinos te encuentren.'
  }, {
    sin: 'En la entrevista técnica te preguntan cosas que sabés pero no podés explicar bajo presión.',
    con: '20 preguntas técnicas con respuesta modelo y 3 sesiones de simulacro previas con IA.'
  }, {
    sin: 'Usás ChatGPT para copiar código sin entender nada y en el oral se nota.',
    con: '50 prompts para aprender más rápido, no para copiar. La diferencia que nota el docente.'
  }, {
    sin: 'Llegás a época de finales sin organizarte y todo se acumula en 2 semanas.',
    con: 'Planificador de cuatrimestre con countdown de finales, tracker de materias y sistema de alertas automáticas.'
  }, {
    sin: 'Aplazás y no entendés por qué. Volvés a hacer lo mismo en el siguiente intento.',
    con: 'Sistema de diagnóstico post-aplazo para identificar la causa real y resolverla antes del siguiente intento.'
  }, {
    sin: 'Buscás trabajo pero no sabés cuánto pedir ni cómo negociar en el mercado argentino.',
    con: 'Salarios reales 2026, estrategia de negociación y dónde buscar trabajo IT en Argentina.'
  }, {
    sin: 'Sin sistema de referencia rápida. Cada vez que tenés una duda perdés 20 minutos buscando en Google.',
    con: 'Cheat Sheets de Python, Java y SQL siempre disponibles. La respuesta en 10 segundos.'
  }];
  return <section className="bg-megapack-card py-10 md:py-16 px-4 md:px-6" data-id="element-36">
      <div className="max-w-6xl mx-auto w-[92%] md:w-full" data-id="element-37">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold text-center mb-8 md:mb-16" data-id="element-38">
          ¿Cuánto cuesta NO tener el Mega Pack?
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-39">
          {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-40">
              <div className="hidden md:flex bg-megapack-bg border border-megapack-red/10 p-6 rounded-2xl items-start gap-4" data-id="element-41">
                <span className="text-megapack-red text-xl shrink-0" data-id="element-42">❌</span>
                <p className="text-megapack-gray text-sm leading-relaxed" data-id="element-43">
                  <span className="text-white font-bold block mb-1" data-id="element-44">
                    Sin Mega Pack:
                  </span>{' '}
                  {row.sin}
                </p>
              </div>
              <div className="bg-megapack-section border border-megapack-green/20 p-4 md:p-6 rounded-2xl flex items-start gap-3 md:gap-4" data-id="element-45">
                <span className="text-megapack-green text-xl shrink-0" data-id="element-46">✅</span>
                <p className="text-white/90 text-[15px] md:text-sm leading-relaxed" data-id="element-47">
                  <span className="text-megapack-cyan font-bold block mb-1" data-id="element-48">
                    Con Mega Pack:
                  </span>{' '}
                  {row.con}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 md:mt-24 text-center" data-id="element-49">
          <h3 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-4 leading-tight" data-id="element-50">
            El próximo lunes podés seguir sin método.{' '}
            <br className="hidden md:block" data-id="element-51" />O podés tener el sistema completo
            desde hoy.
          </h3>
          <p className="text-megapack-gray text-[15px] md:text-xl" data-id="element-52">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>
      </div>
    </section>;
};